<form>
	<ui-modal size="md" modalTitle="Dependencies Details">
		<div *ngIf="details && list && list.length">
			<div class="d-flex">
				<div class="form-group flex-weight-1">
					<div class="col-form-label">Dependencies</div>
					<div class="input-group">
						<select class="custom-select" (ngModelChange)="dependencyChange($event)" [(ngModel)]="selectedIndex" [ngModelOptions]="{standalone: true}">
							<option *ngFor="let d of list; let i = index" [ngValue]="i">{{d.dependency_name}}</option>
						</select>
					</div>
				</div>
			</div>

			<div class="d-flex" *ngIf="details?.type === 'text'">
				<div class="form-group flex-weight-1">
					<div class="col-form-label">Text Content</div>
					<div class="input-group">
						<textarea class="form-control" [(ngModel)]="details.text_content" [ngModelOptions]="{ standalone: true }"></textarea>
					</div>
				</div>
			</div>
			<div *ngIf="details?.type === 'photo'">
				<div class="d-flex justify-content-center">
					<div class="img-container d-flex hover-parent border border-4 border-lightgrey" [style.backgroundImage]="'url(\'' + ((details.image_data.length && details.image_data[currentIndex].image_url) || 'assets/img/image-placeholder.png') + '\')' | safeStyle">
						<div class="hover-child d-inline-block" style="margin: auto;">
							<button *ngIf="details.image_data.length && details.image_data[currentIndex].image_id" type="button" class="btn btn-danger mt-3" [disabled]="disabled" (click)="removeImage(currentIndex)"><i class="wq wq-delete mr-2"></i>Remove Image</button>
							<button type="button" class="btn btn-medium mt-3" [disabled]="disabled" (click)="openMediaLibrary(currentIndex)"><i class="wq wq-edit mr-2"></i>Select Image</button>
						</div>
					</div>
				</div>
				<div *ngIf="details.image_data.length && details.image_data.length > 0" class="d-flex justify-content-end mt-2">
					<a class="btn btn-primary mr-2" [href]="details.image_data[currentIndex].image_url" target="_blank" download><i class="wq wq-download mr-2"></i>Download</a>
					<button type="button text-center" class="btn btn-primary" (click)="addMoreImages()"><i class="wq wq-add mr-2"></i>Add More Images</button>
				</div>
				<div *ngIf="details.image_data && details.image_data.length > 0" class="mt-3 snaggs-container">
					<div *ngFor="let image of details.image_data; let i = index" class="img-container" [ngClass]="{'border border-4 border-lightgrey': i === currentIndex}" [style.backgroundImage]="'url(' + image.image_url + ')'" (click)="setMainImage(i)"></div>
				</div>
			</div>
			<div *ngIf="details?.type === 'signature'">
				<div class="d-flex justify-content-center" *ngIf="details.image_url && details.image_id">
					<div class="img-container d-flex hover-parent border border-4 border-lightgrey" [style.backgroundImage]="'url(\'' + (details.image_url) + '\')' | safeStyle">
					</div>
				</div>
				<ng-container *ngIf="!details.image_url && !details.image_id">
					<div class="d-flex">
						<div class="text-secondary mb-2 mr-3 flex-weight-1" [ngClass]="{ invisible: !signatureEmpty }">Draw your signature in the box.</div>
						<div><button class="btn btn-sm btn-outline-secondary" [ngClass]="{ invisible: signatureEmpty }" (click)="resizeCanvas()">Clear Signature</button></div>
					</div>
					<div (resized)="resizeCanvas()">
						<canvas class="border border-lightgrey rounded" style="width: 100%; height: 150px;" #spCanvas></canvas>
					</div>
				</ng-container>


			</div>
		</div>

		<button type="button" class="btn btn-medium" (click)="modal.close()" [disabled]="disabled" ui-modal-footer>Cancel</button>
		<button type="submit" class="btn btn-primary" (click)="save()" [disabled]="disabled" ui-modal-footer>Save</button>
	</ui-modal>
</form>
